module.exports = __webpack_public_path__ + "img/body-position-chart-slide1.bc48807a.gif";